<!-- 案件卡片 -->
<template>
    <div class="case-card">
        <div class="title">{{ caseInfo.case_title }}</div>
        <div class="content">
            {{ content }}
        </div>
        <div class="other">
            <div class="time">{{ caseInfo.case_time | dateFilter }}</div>
            <div v-if="caseInfo.case_domain && caseInfo.case_time">&nbsp;|&nbsp;</div>
            <div class="domain">{{ caseInfo.case_domain }}</div>
        </div>
        <div v-if="money" class="bottom">
            为当事人挽回经济损失{{ money }}万元
        </div>
    </div>
</template>

<script>
import {dateFilter} from '@/utils/filter';

export default {
    props: {
        caseInfo: {
            type: Object,
            default: () => {}
        }
    },
    computed: {
        content() {
            return this.caseInfo.case_content?.replace(/<.*?>/g, '');
        },
        money() {
            let moneys = this.caseInfo?.case_result?.match(/\d+/g);
            let money = moneys?.[0];
            return Number(money) || 0;
        }
    },
    filters: {
        dateFilter
    }
};
</script>

<style lang='less' scoped>
.case-card {
    width: 520px;
    height: 300px;
    border: 0.52px solid rgba(222,223,224,0.50);
    box-shadow: 0 4px 16px 0 rgba(97,98,104,0.04);
    border-radius: 8px;
    padding: 30px 32px 32px;
    position: relative;
    .small_sise(20px, top);

    .title {
        font-family: PingFangSC-Medium;
        font-size: 20px;
        color: #1E1F24;
        line-height: 1.3;
        font-weight: 500;
        .text-overflow-ellipsis(1);
    }

    .content {
        margin-top: 18px;
        width: 120%;
        .text-overflow-ellipsis(3);
        transform: scale(0.8);
        transform-origin: left top;
        color: #848691;
    }

    .other {
        display: flex;
        color: #848691;
        margin-top: 12px;
        position: absolute;
        top: 156px;
        transform: scale(0.8);
        transform-origin: left top;
    }

    .bottom {
        height: 60px;
        line-height: 60px;
        padding: 0 16px 0 42px;
        background: #F9FAFC;
        border: 2px solid rgba(222, 223, 224, 0.5);
        border-radius: 10px;
        position: absolute;
        bottom: 32px;
        width: 105%;
        transform: scale(0.8);
        transform-origin: left top;
        .text-overflow-ellipsis(1);

        &:before {
            height: 20px;
            width: 20px;
            content: '';
            display: inline-block;
            position: absolute;
            top: 50%;
            left: 12px;
            transform: translateY(-50%);
            background: url('https://lvlin-base.cdn.bcebos.com/fe-saas/page/personal-info/case-icon.png') no-repeat center center / 100%;
        }
    }
}
</style>
